import styled from "styled-components";
import { Link as LinkS } from "react-scroll";
import { HashLink as LinkH } from "react-router-hash-link";

export const HomeWrapper = styled.div`
  @media screen and (max-width: 576px) {
    /* margin-top: 60px; */
  }
`;

export const VideoWrapper = styled.div`
  height: 100vh;
  position: relative;
`;

export const VideoBg = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const VideoMsg = styled.div`
  font-family: Oswald;
  color: ${({ theme }) => theme.color1};
  -webkit-text-stroke-width: 0.5px;
  -webkit-text-stroke-color: ${({ theme }) => theme.color3};
  position: absolute;
  bottom: 100px;
  left: 50px;
  width: 350px;
  font-size: 3em;
  font-weight: bold;
  @media screen and (max-width: 576px) {
    width: 250px;
    font-size: 2em;
  }
`;
export const ScrollIcon = styled(LinkS)`
  @keyframes iconMove {
    50% {
      bottom: 20px;
    }
  }
  position: absolute;
  bottom: 10px;
  left: 50%;
  font-size: 3em;
  font-weight: bold;
  cursor: pointer;
  color: ${({ theme }) => theme.color1};
  animation: iconMove 2s infinite;
  :hover {
    color: ${({ theme }) => theme.color2};
    animation: 0;
  }
  @media screen and (max-width: 576px) {
    font-size: 2em;
  }
`;
export const ProjectsWrapper = styled.div`
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;
export const PeopleWrapper = styled.div`
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;
export const ContactWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  margin-bottom: 80px;
  flex-wrap: wrap;
  @media screen and (max-width: 576px) {
    /* height: 400px; */
  }
`;

export const ContactCard = styled(LinkH)`
  position: relative;
  margin: 0px 30px;
  width: 70%;
  max-height: 100%;
  cursor: pointer;
  overflow: hidden;
  @media screen and (max-width: 576px) {
    margin: 0px;
  }
  ::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-image: ${({ theme }) =>
      "linear-gradient(to right, " +
      theme.color1 +
      "bf , " +
      theme.color1 +
      "ff)"};
  }
  img {
    max-width: 100%;
    object-fit: cover;
    /* transform: scale(1); */
    transition: all 1s;
  }
  :hover {
    button {
      background-color: ${({ theme }) => theme.color3};
      color: ${({ theme }) => theme.color1};
    }
    img {
      transform: scale(1.1);
    }
  }
`;

export const ContactTextWrapper = styled.div`
  font-family: Oswald;
  z-index: 1;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 50px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${({ theme }) => theme.color3};
  text-align: center;
  @media screen and (max-width: 576px) {
    left: 50%;
    transform: translate(-50%, -50%);
  }
  h1 {
    font-size: 2em;
    margin: 10px;
    text-transform: uppercase;
    font-weight: 900;
    @media screen and (max-width: 576px) {
      font-size: 1.5em;
    }
  }
  p {
    font-size: 1.5em;
    @media screen and (max-width: 576px) {
      font-size: 1em;
    }
  }
  button {
    font-weight: 600;
    font-size: 1.5em;
    margin: 10px;
    padding: 5px 10px;
    background-color: transparent;
    color: ${({ theme }) => theme.color3};
    border: ${({ theme }) => "4px solid " + theme.color3};
    cursor: pointer;
    transition: all 0.5s;
    @media screen and (max-width: 576px) {
      font-size: 1em;
    }
  }
`;

export const ServicesWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const ServiceCardsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto 20px;
  min-height: 400px;
  border-radius: 20px;
  flex-wrap: wrap;
  @media screen and (max-width: 576px) {
    margin: auto 0px;
  }
`;

export const ServiceCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 20px 10px;
  height: 400px;
  width: 250px;
  border-radius: 20px;
  border: 1px solid;
  color: ${({ theme }) => theme.color1};
  cursor: pointer;
  overflow: hidden;
  transition: all 0.5s;
  @media screen and (max-width: 576px) {
    margin: 20px 0px;
  }
  :last-child {
    margin-right: 0px;
  }
  img {
    height: 80%;
    width: 100%;
    object-fit: cover;
  }
  h1 {
    margin: auto 5px;
    text-align: center;
  }
  ::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: transparent;
    transition: all 0.5s;
  }
  :hover {
    ::before {
      background-color: ${({ theme }) => theme.color1}5f;
    }
  }
`;
